import AccessTimeIcon from '@mui/icons-material/AccessTime';
import EventIcon from '@mui/icons-material/Event';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import GroupsIcon from '@mui/icons-material/Groups';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Chip from '@mui/material/Chip';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom';

const EventInfo = () => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                py: { xs: 8, md: 12 },
                background: `radial-gradient(ellipse at 20% 10%, ${theme.palette.primary.main}10 0%, transparent 40%), radial-gradient(ellipse at 80% 0%, ${theme.palette.secondary.main}10 0%, transparent 45%), linear-gradient(135deg, ${theme.palette.grey[50]} 0%, white 60%, ${theme.palette.primary.main}08 100%)`,
                position: 'relative',
                overflow: 'hidden',
            }}
        >
            {/* Decorative background */}
            <Box
                sx={{
                    position: 'absolute',
                    top: -60,
                    right: -60,
                    width: 220,
                    height: 220,
                    borderRadius: '50%',
                    background: `linear-gradient(45deg, ${theme.palette.primary.main}15, ${theme.palette.secondary.main}15)`,
                    zIndex: 0,
                }}
            />
            <Box
                sx={{
                    position: 'absolute',
                    bottom: -120,
                    left: -120,
                    width: 320,
                    height: 320,
                    borderRadius: '50%',
                    background: `linear-gradient(45deg, ${theme.palette.secondary.main}10, ${theme.palette.primary.main}10)`,
                    zIndex: 0,
                }}
            />

            <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
                <Card
                    sx={{
                        borderRadius: 4,
                        background: `linear-gradient(135deg, ${theme.palette.primary.main}12 0%, ${theme.palette.secondary.main}10 100%)`,
                        border: `1px solid ${theme.palette.primary.main}30`,
                        boxShadow: '0 16px 50px rgba(0,0,0,0.12)',
                        backdropFilter: 'blur(6px)',
                    }}
                >
                    <CardContent sx={{ p: { xs: 3, md: 5 } }}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                mb: 3,
                            }}
                        >
                            <EventIcon
                                sx={{
                                    fontSize: 36,
                                    color: theme.palette.primary.main,
                                    mr: 2,
                                }}
                            />
                            <Box sx={{ flexGrow: 1 }}>
                                <Stack
                                    direction="row"
                                    spacing={1}
                                    alignItems="center"
                                >
                                    <Typography
                                        variant="h5"
                                        sx={{
                                            fontWeight: 800,
                                            color: 'text.primary',
                                        }}
                                    >
                                        INAACC Semarang 2026
                                    </Typography>
                                    <Chip
                                        label="Upcoming"
                                        color="secondary"
                                        size="small"
                                        sx={{ fontWeight: 700, color: 'white' }}
                                    />
                                </Stack>
                                <Stack
                                    direction="row"
                                    spacing={1}
                                    alignItems="center"
                                    sx={{ mt: 0.5 }}
                                >
                                    <LocationOnIcon
                                        sx={{
                                            fontSize: 18,
                                            color: 'text.secondary',
                                        }}
                                    />
                                    <Typography
                                        variant="body2"
                                        color="text.secondary"
                                    >
                                        Padma Hotel, Semarang
                                    </Typography>
                                    <Divider
                                        flexItem
                                        orientation="vertical"
                                        sx={{ mx: 1 }}
                                    />
                                    <CalendarTodayIcon
                                        sx={{
                                            fontSize: 18,
                                            color: 'text.secondary',
                                        }}
                                    />
                                    <Typography
                                        variant="body2"
                                        color="text.secondary"
                                    >
                                        9 – 11 April 2026
                                    </Typography>
                                </Stack>
                            </Box>
                            <Button
                                variant="contained"
                                color="primary"
                                size="medium"
                                href="https://calendar.google.com/calendar/render?action=TEMPLATE&text=INA-ACC%20Semarang%202026&details=Annual%20scientific%20meeting&location=Padma%20Hotel%20Semarang&dates=20260409/20260411"
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{
                                    borderRadius: 2,
                                    textTransform: 'none',
                                    fontWeight: 700,
                                }}
                            >
                                Add to Calendar
                            </Button>
                        </Box>

                        <Divider sx={{ mb: 4 }} />

                        <Grid container spacing={3}>
                            <Grid item xs={12} md={7}>
                                <Box
                                    sx={{
                                        p: { xs: 2.5, md: 3 },
                                        backgroundColor: 'white',
                                        borderRadius: 3,
                                        border: `1px solid ${theme.palette.grey[200]}`,
                                        boxShadow:
                                            '0 6px 18px rgba(0,0,0,0.06)',
                                    }}
                                >
                                    <Stack
                                        direction="row"
                                        spacing={1.5}
                                        alignItems="center"
                                        sx={{ mb: 2 }}
                                    >
                                        <AccessTimeIcon
                                            sx={{
                                                fontSize: 24,
                                                color: theme.palette.primary
                                                    .main,
                                            }}
                                        />
                                        <Typography
                                            variant="h6"
                                            sx={{
                                                fontWeight: 700,
                                                color: 'text.primary',
                                            }}
                                        >
                                            Date & Time
                                        </Typography>
                                    </Stack>
                                    <Typography
                                        variant="h4"
                                        sx={{
                                            fontWeight: 800,
                                            color: 'text.primary',
                                        }}
                                    >
                                        9 – 11 April 2026
                                    </Typography>
                                    <Stack
                                        direction="row"
                                        spacing={1}
                                        flexWrap="wrap"
                                        sx={{
                                            mt: 2,
                                            justifyContent: {
                                                xs: 'center',
                                                sm: 'flex-start',
                                            },
                                            gap: 1,
                                        }}
                                    >
                                        <Chip
                                            size="small"
                                            color="primary"
                                            label="3-day event"
                                            sx={{ fontWeight: 700 }}
                                        />
                                        <Chip
                                            size="small"
                                            variant="outlined"
                                            label="Conference"
                                        />
                                        <Chip
                                            size="small"
                                            variant="outlined"
                                            label="Hands-on Workshops"
                                        />
                                        <Chip
                                            size="small"
                                            variant="outlined"
                                            label="Exhibition"
                                        />
                                    </Stack>
                                </Box>
                            </Grid>
                            <Grid item xs={12} md={5}>
                                <Box
                                    sx={{
                                        p: { xs: 2.5, md: 3 },
                                        borderRadius: 3,
                                        background: 'white',
                                        border: `1px solid ${theme.palette.grey[200]}`,
                                        boxShadow:
                                            '0 6px 18px rgba(0,0,0,0.06)',
                                    }}
                                >
                                    <Stack spacing={2}>
                                        <Stack
                                            direction="row"
                                            spacing={1.5}
                                            alignItems="center"
                                        >
                                            <StarBorderIcon
                                                sx={{
                                                    fontSize: 24,
                                                    color: theme.palette.warning
                                                        .main,
                                                }}
                                            />
                                            <Typography
                                                variant="subtitle1"
                                                sx={{ fontWeight: 700 }}
                                            >
                                                Keynotes & Latest Updates
                                            </Typography>
                                        </Stack>
                                        <Stack
                                            direction="row"
                                            spacing={1.5}
                                            alignItems="center"
                                        >
                                            <GroupsIcon
                                                sx={{
                                                    fontSize: 24,
                                                    color: theme.palette.info
                                                        .main,
                                                }}
                                            />
                                            <Typography
                                                variant="subtitle1"
                                                sx={{ fontWeight: 700 }}
                                            >
                                                Networking & Community
                                            </Typography>
                                        </Stack>
                                        <Stack
                                            direction="row"
                                            spacing={1.5}
                                            alignItems="center"
                                        >
                                            <LocationOnIcon
                                                sx={{
                                                    fontSize: 24,
                                                    color: theme.palette.success
                                                        .main,
                                                }}
                                            />
                                            <Typography
                                                variant="subtitle1"
                                                sx={{ fontWeight: 700 }}
                                            >
                                                Scenic Venue & Exhibition
                                            </Typography>
                                        </Stack>
                                    </Stack>
                                    <Stack
                                        direction={{ xs: 'column', sm: 'row' }}
                                        spacing={1.5}
                                        sx={{ mt: 1.5 }}
                                    >
                                        <Button
                                            component={Link}
                                            to="/signin"
                                            variant="outlined"
                                            color="primary"
                                            size="large"
                                            sx={{
                                                flex: 1,
                                                borderRadius: 2,
                                                textTransform: 'none',
                                                fontWeight: 700,
                                            }}
                                        >
                                            Login
                                        </Button>
                                        <Button
                                            component={Link}
                                            to="/signup"
                                            variant="contained"
                                            color="secondary"
                                            size="large"
                                            sx={{
                                                flex: 1,
                                                borderRadius: 2,
                                                textTransform: 'none',
                                                fontWeight: 700,
                                            }}
                                        >
                                            Register
                                        </Button>
                                    </Stack>
                                </Box>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Container>
        </Box>
    );
};

export default EventInfo;
